import authBaseAxios from "../utils/api";
import { IEspResponse, IEspTable, IEspTableDataResponse } from "../interfaces/expect-supplier-payment";
import qs from "qs";

export const ExpectingSupplierPaymentServices = {
  getAllAndRow: (fieldRow: string, params: any): Promise<IEspResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`expect-supplier-payments/${fieldRow}?${queryString}`);
  },
  getDropdownByType: (type: string) => {
    return authBaseAxios.get(`/expect-supplier-payments/dropdown-data?type=${type}`);
  },

  getDetailBySupplierAndBooking: (params?: any): Promise<IEspTableDataResponse> => {
    return authBaseAxios.get("expect-supplier-payments/details", params);
  },
  updateDetailBookingSupplierCost: (bookingRef: string, supplierCode: string, body: IEspTable[], matchingId?: number): Promise<any> => {
    return authBaseAxios.put(`/expect-supplier-payments/details`, { bookingRef, supplierCode, espTables: body, matchingId });
  },
  changeWorkflow: (input: any): Promise<any> => {
    return authBaseAxios.put(`/expect-supplier-payments/change-workflow`, input);
  },
};
